<template>
  <card class="daily-nudge" :has-content-padding="false">
    <div class="nudge-question">{{ dailyNudgeQuestion }}</div>
    <div class="answer-wrapper">
      <div class="answer-button" :class="{ 'disabled': dailyNudgeAnswer !== null }" v-on:click="handleAnswer(true)">
        <template v-if="dailyNudgeAnswer === true">
          <lottie-player class="ripple-animation"
                       :src="JSON.stringify(require('@/assets/challenge/loties/Succsess-ripple.json'))" :autoplay="true"/>
          <img class="circle" :src="require('@/assets/challenge/green-v.svg')">
        </template>
        <img class="circle" v-else :src="require('@/assets/challenge/blue-v.svg')">
      </div>
      <div class="vertical-separator"/>
      <div class="answer-button" :class="{ 'disabled': dailyNudgeAnswer !== null }" v-on:click="handleAnswer(false)">
        <template v-if="dailyNudgeAnswer === false">
          <lottie-player class="ripple-animation"
                         :src="JSON.stringify(require('@/assets/challenge/loties/Fail-ripple.json'))" :autoplay="true"/>
          <img class="circle" :src="require('@/assets/challenge/red-x.svg')">
        </template>
        <img class="circle" v-else :src="require('@/assets/challenge/blue-x.svg')">
      </div>
    </div>
  </card>
</template>

<script>

// import { mapActions } from 'vuex';

import BaseUI from 'base-ui';

export default {
  name: 'DailyNudge',
  components: {
    Card: BaseUI.Card,
  },
  props: {
    dailyNudgeQuestion: {
      required: true,
      type: String,
    },
    dailyNudgeAnswer: {
      type: Boolean,
    },
  },
  methods: {
    handleAnswer(answer) {
      if (this.dailyNudgeAnswer !== null) {
        return;
      }
      this.$emit('daily-nudge-answered', answer);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';
.daily-nudge {
  width: 100%;
  background-color: $riseup-white;
  padding: 30px 30px 0;
  position: relative;
  .nudge-question {
    width: 100%;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    line-height: 33.6px;
    text-align: center;
  }
  .answer-wrapper {
    height: 120px;
    width: 100%;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;

    .answer-button {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &.disabled {
        cursor: default;
      }
      .ripple-animation {
        position: absolute;
        height: 100px;
        width: 100px;
      }
      .circle {
        height: 66px;
        width: 66px;
      }
    }
    .vertical-separator {
      width: 1px;
      background: $riseup_gray_0;
      margin: 20px 0;
    }
  }
}

</style>
